var map = {
	"./feature_buy_en.png": "a539",
	"./feature_buy_id.png": "23c1",
	"./feature_buy_ph.png": "7584",
	"./feature_buy_th.png": "4afc",
	"./feature_buy_zh.png": "d30a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f24e";